var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestSuiteHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86585 10.1341L1.86585 12.7778C1.86585 13.4562 2.20977 14.0884 2.77935 14.4569L5.24049 16.0494C7.22399 17.3329 9.77601 17.3329 11.7595 16.0494L14.2206 14.4569C14.7902 14.0884 15.1341 13.4562 15.1341 12.7778L15.1341 10.1341",
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.327 4.40606C7.64933 3.55044 9.35067 3.55044 10.673 4.40606L14.405 6.82086C15.623 7.60898 15.623 9.39102 14.405 10.1791L10.673 12.5939C9.35067 13.4496 7.64932 13.4496 6.32699 12.5939L2.59503 10.1791C1.37704 9.39102 1.37704 7.60898 2.59503 6.82086L6.327 4.40606Z",
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4135 6.6148C8.07466 6.18698 8.92534 6.18698 9.5865 6.6148L12.3702 8.41604C12.4311 8.45545 12.4311 8.54455 12.3702 8.58396L9.5865 10.3852C8.92534 10.813 8.07466 10.813 7.4135 10.3852L4.62975 8.58396C4.56885 8.54455 4.56885 8.45545 4.62975 8.41604L7.4135 6.6148Z",
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSuiteHover);
export default __webpack_public_path__ + "static/media/test-suite-hover.d03179cebfad909f8c6446baf815286d.svg";
export { ForwardRef as ReactComponent };